import { render, staticRenderFns } from "./pos-ViewPurchase.vue?vue&type=template&id=a65be984"
import script from "./pos-ViewPurchase.vue?vue&type=script&lang=js"
export * from "./pos-ViewPurchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports